import styled, { css } from 'styled-components';
import { FlexCenterAligned } from '../../../styled/common';
import { tagStyles } from '../../ui/Typography/styles';

export const Dot = styled.div`
  width: 10px;
  height: 10px;
  background-color: ${({ theme }) => theme.colors.systemColors.black};
  border-radius: 50%;
  position: relative;
  transition: background-color 0.2s ease-in-out;
  cursor: pointer;
`;

export const MarkerWrapper = styled(FlexCenterAligned)`
  position: absolute;
  left: calc(50% + 4px);
  transform: translateX(-50%);
  bottom: calc(100% + 7px);
  height: 32px;
  padding: 0 15px;
  border-radius: 25px;
  background-color: ${({ theme }) => theme.colors.systemColors.black};
  color: ${({ theme }) => theme.colors.text.white};
  ${tagStyles.body_3};
  cursor: pointer;
  white-space: nowrap;
  transition:
    background-color 0.2s ease-in-out,
    z-index 0.2s ease-in-out;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${({ theme }) => theme.colors.systemColors.black};
    transition: border-top-color 0.2s ease-in-out;
  }
`;

const activeMarkerStyles = css`
  z-index: 2;

  ${MarkerWrapper} {
    background-color: ${({ theme }) => theme.colors.systemColors.blue};
  }

  ${Dot} {
    background-color: ${({ theme }) => theme.colors.systemColors.blue};
  }

  ${MarkerWrapper}::after {
    border-top-color: ${({ theme }) => theme.colors.systemColors.blue};
  }
`;

export const MarkerContainer = styled.div<{ $isActive: boolean }>`
  position: relative;
  width: 1px;
  height: 1px;
  z-index: 1;

  ${({ $isActive }) => $isActive && activeMarkerStyles}

  @media (hover: hover) {
    &:hover {
      ${activeMarkerStyles};
    }
  }
`;
